import { GetterTree } from 'vuex';
import { RootState } from '@/types/store';
import { instantLottoState } from '@/types/instant';

export const getters: GetterTree<instantLottoState, RootState> = {
    allCartInstant: (state) => state.cartInstant,
};

export default getters;
